function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Fonts",
  transform: "translate(-835.000000, -3259.000000)",
  stroke: "#80A1FE"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons/Regular/Bell",
  transform: "translate(836.000000, 3260.854741)"
}, /*#__PURE__*/React.createElement("g", {
  id: "bell"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20,15.0026582 L0,15.0026582 C1.65685425,15.0026582 3,13.6592744 3,12.0021266 L3,7.00124045 C3.00000006,3.1345621 6.13400679,-4.44167913e-16 10,0 C13.8659932,4.44167913e-16 16.9999999,3.1345621 17,7.00124045 L17,12.0021266 C17,13.6592744 18.3431458,15.0026582 20,15.0026582 Z M11.73,19.0033671 C11.3722022,19.6202808 10.7130686,20 10,20 C9.28693139,20 8.62779776,19.6202808 8.27,19.0033671 L11.73,19.0033671 Z",
  id: "Shape",
  strokeWidth: 2
})))));

var SvgNotificationBellOutlined = function SvgNotificationBellOutlined(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "23px",
    viewBox: "0 0 22 23",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotificationBellOutlined, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notification-bell-outlined.1a3c9698.svg";
export { ForwardRef as ReactComponent };